import axios from 'axios';
import {type ActionTree} from 'vuex';
import {deepCopyObject, XHR_STATUS_DEFAULT} from '../../../../utils/portuna';

const actions: ActionTree<ModuleServicesState, RootState> = {
    fetchServiceOptions({commit}): Promise<ServiceCalendarResourceOptions>
    {
        return new Promise((resolve, reject) =>
        {
            axios.get('/services/calendar/fetch-options').then(response =>
            {
                if (response.data.status !== XHR_STATUS_DEFAULT)
                {
                    // trigger catch with response
                    throw response;
                }

                const {data} = response.data;

                commit('setCalendarOptions', data);

                resolve(data);
            })
            .catch(reject);
        });
    },
    fetchBookingInformation({commit}, token?: string)
    {
        let params = token ? '/token/' + token : '';

        return new Promise((resolve, reject) =>
        {
            axios.get('/booking/booking/fetch' + params).then(response =>
            {
                if (response.data.status !== XHR_STATUS_DEFAULT)
                {
                    // trigger catch with response
                    throw response;
                }

                const {data} = response.data;

                commit('setBookingInformation', data.information);
                commit('setDefaultAddress', data.information.address);
                commit('setBookingServices', data.services);
                commit('setBookingCategories', data.categories);
                commit('setBookingCalendars', data.calendars);

                resolve(data);
            })
            .catch(reject);
        });
    },
    setBookingData({commit}, data: BookingData)
    {
        commit('setBookingData', deepCopyObject(data));
    },
    setInformation({commit}, data: Nullable<BookingInformation>)
    {
        commit('setBookingInformation', deepCopyObject(data));
    },
    setServices({commit}, data: Nullable<BookingServiceData[]>)
    {
        commit('setServiceData', deepCopyObject(data));
    },
};

export default actions;